// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a6618879","75":"54b8f3ac","379":"41c0d1cb","442":"b9fe8f02","501":"41c0d1cb","654":"1d280de7","742":"0dd13af1"}[chunkId] + ".chunk.css";
};